import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-close-circle",
  "use": "icon-close-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-close-circle\">\r\n  <path d=\"M8,16a8,8,0,1,1,8-8A8.009,8.009,0,0,1,8,16ZM8,8.884H8l2.058,2.058a.625.625,0,0,0,.884-.884L8.884,8l2.058-2.058a.625.625,0,0,0-.884-.884L8,7.116,5.942,5.058a.625.625,0,0,0-.884.884L7.116,8,5.058,10.058a.625.625,0,0,0,.884.884L8,8.885Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol